var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 75,
    viewBox: "0 0 94 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3607 73.0469C30.7727 73.0469 39.2133 64.6063 39.2133 54.1944C39.2133 43.7824 30.7727 35.3418 20.3607 35.3418C9.94876 35.3418 1.50818 43.7824 1.50818 54.1944C1.50818 64.6063 9.94876 73.0469 20.3607 73.0469Z",
    stroke: "#005A44",
    strokeWidth: 2.42251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9722 73.0469C84.3842 73.0469 92.8247 64.6063 92.8247 54.1944C92.8247 43.7824 84.3842 35.3418 73.9722 35.3418C63.5602 35.3418 55.1196 43.7824 55.1196 54.1944C55.1196 64.6063 63.5602 73.0469 73.9722 73.0469Z",
    stroke: "#005A44",
    strokeWidth: 2.2651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2419 24.8237C72.2419 24.8237 56.624 20.9551 67.2416 36.2389",
    stroke: "#005A44",
    strokeWidth: 2.42251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0975 18.0438C29.5859 17.5638 29.7081 17.0438 29.7081 16.8438H30.9294V19.2438L29.7081 19.8438C29.301 19.4438 28.609 18.5238 29.0975 18.0438Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9294 33.8455C32.7294 29.8455 34.0961 17.3455 35.4294 11.8455C38.6295 10.2455 42.7628 10.1788 44.4294 10.3455C45.0961 16.1788 46.0294 28.1455 44.4294 29.3455C42.8294 30.5455 38.2627 33.0121 35.9294 33.8455Z",
    fill: "#0A429A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9295 32.3438C29.7295 34.3438 33.9295 34.1771 35.9295 33.8438C33.9295 25.3438 35.9295 12.8438 35.9295 11.8438C35.9295 10.8438 32.4295 10.8438 31.4295 11.8438C30.4295 12.8438 27.9295 29.8438 28.9295 32.3438Z",
    fill: "#326AC2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4294 9.34461L35.9294 11.8446H31.4294C31.2544 11.8446 30.4294 15.8446 29.9294 17.8446L27.9294 18.8446C28.4294 16.6779 29.6294 12.1446 30.4294 11.3446C31.4294 10.3446 36.9294 9.34461 38.9294 8.84461C40.5294 8.44461 43.2628 9.01128 44.4294 9.34461Z",
    fill: "#528BE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7534 19.5786C53.7534 8.76332 53.1841 0 48.9371 0C41.2475 0 37.1095 9.04963 37.1095 19.8649C37.1095 19.8649 36.421 40.1252 46.1762 58.8755C46.7727 60.0242 49.3223 60.9274 49.7961 59.7242C56.9778 41.492 53.7499 19.5786 53.7499 19.5786H53.7534Z",
    fill: "#005A44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6265 19.5786C56.6265 8.76332 53.1839 0 48.9403 0C44.6967 0 41.2541 8.76673 41.2541 19.5786C41.2541 19.5786 40.8996 41.4886 48.0814 59.7242C48.5552 60.9274 49.3255 60.9274 49.8027 59.7242C56.9844 41.492 56.6299 19.5786 56.6299 19.5786H56.6265Z",
    fill: "#2AC682"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8504 34.3927C53.2091 34.3927 55.1212 28.7966 55.1212 21.8936C55.1212 14.9905 53.2091 9.39453 50.8504 9.39453C48.4916 9.39453 46.5795 14.9905 46.5795 21.8936C46.5795 28.7966 48.4916 34.3927 50.8504 34.3927Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4294 21.3438C44.2294 16.5437 38.9294 12.8438 35.9294 11.8438L37.4294 11.3438C38.2294 11.3438 40.7628 13.0104 41.9294 13.8438C46.4294 17.8438 45.4294 21.8438 43.9294 25.3438C42.7294 28.1437 39.2628 31.0104 37.9294 31.8438L35.9294 32.3438C38.2628 30.6771 42.6294 26.1438 43.4294 21.3438Z",
    fill: "#326AC2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0652 19.866C51.4511 19.866 51.764 18.9809 51.764 17.8891C51.764 16.7972 51.4511 15.9121 51.0652 15.9121C50.6793 15.9121 50.3665 16.7972 50.3665 17.8891C50.3665 18.9809 50.6793 19.866 51.0652 19.866Z",
    fill: "#005A44"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9151 19.866C54.156 19.866 54.3513 18.9809 54.3513 17.8891C54.3513 16.7972 54.156 15.9121 53.9151 15.9121C53.6741 15.9121 53.4788 16.7972 53.4788 17.8891C53.4788 18.9809 53.6741 19.866 53.9151 19.866Z",
    fill: "#005A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.6beba1572579bd3352980846bf9c6648.svg";
export { ForwardRef as ReactComponent };